import postWithTokenRefresh from './postWithTokenRefresh';
export const FEEDBACK_ENDPOINT = '/client-feedback';

/**
 * Sends one feedback submission. Unlike error telemetry this is user-initiated, so failures are
 * rethrown for the panel to show instead of being swallowed.
 */
export const submitFeedback = payload => postWithTokenRefresh(FEEDBACK_ENDPOINT, payload);